import {
  VERIFY_EMAIL_OTP,
  VERIFY_EMAIL_OTP_SUCCESSFUL,
  VERIFY_EMAIL_OTP_FAILED,
  SEND_EMAIL,
  SEND_EMAIL_SUCCESSFUL,
  SEND_EMAIL_FAILED,
  RESET_VERIFY_EMAILOTP_ERRORS,
  UPDATE_NEW_EMAIL,
  UPDATE_NEW_EMAIL_SUCCESS,
  UPDATE_NEW_EMAIL_FAILED,
} from "./actionTypes"

const initialState = {
  emailverifyEmailOtpError: null,
  emailotpResponseMessage: null,
  loading: false,
  emailotpVerified: false,
  success: false,
  verifyLoading: false,
  isEmailUpdated: false
}

const emailotpReducer = (state = initialState, action) => {
  switch (action.type) {
    case VERIFY_EMAIL_OTP:
      state = {
        ...state,
        verifyLoading: true,
        success: false,
        emailverifyEmailOtpError: null,
        emailotpVerified: false,
        isEmailUpdated: false
      }
      break
    case VERIFY_EMAIL_OTP_SUCCESSFUL:
      console.log(action.payload)
      state = {
        ...state,
        verifyLoading: false,
        emailotpResponseMessage: action.payload.message,
        emailotpVerified: true,
        success: true,
        emailverifyEmailOtpError: null,
        isEmailUpdated: false
      }
      break
    case VERIFY_EMAIL_OTP_FAILED:
      state = {
        ...state,
        // user: null,
        verifyLoading: false,
        success: false,
        emailverifyEmailOtpError: action.payload,
        emailotpVerified: false,
      }
      break
    case SEND_EMAIL:
      state = {
        ...state,
        loading: true,
        success: false,
        emailverifyEmailOtpError: null,
        isEmailUpdated: false
      }
      break
    case SEND_EMAIL_SUCCESSFUL:
      state = {
        ...state,
        loading: false,
        success: true,
        emailverifyEmailOtpError: null,
        emailotpResponseMessage: "Otp send on your registered email"
      }
      break
    case SEND_EMAIL_FAILED:
      state = {
        ...state,
        // user: null,
        loading: false,
        success: false,
        emailverifyEmailOtpError: action.payload.data.message,
      }
      break
    case RESET_VERIFY_EMAILOTP_ERRORS:
      state = {
        ...state,
        // user: null,
        success: false,
        emailverifyEmailOtpError: null,
        emailotpResponseMessage: null,
        emailotpVerified: false,
        isEmailUpdated: false
      }
      break

    case UPDATE_NEW_EMAIL:
      state = {
        ...state,
        loading: true,
        emailotpResponseMessage: null,
        isEmailUpdated: false

      }
      break
    case UPDATE_NEW_EMAIL_SUCCESS:
      console.log("updated successfully")
      state = {
        ...state,
        loading: false,
        emailotpResponseMessage: action.payload,
        isEmailUpdated: true

      }
      break

    case UPDATE_NEW_EMAIL_FAILED:
      state = {
        ...state,
        loading: true,
        emailotpResponseMessage: null,
        emailverifyEmailOtpError: action.paylaod,
        isEmailUpdated: false

      }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default emailotpReducer;
